// extracted by css-extract-rspack-plugin
export default {"cls1":"Reader-cls1_kUj","cls2":"Reader-cls2_sis Reader-cls1_kUj"};